import Vue from 'vue';
export default {
  data() {
    return {
      stomach: require('@/assets/images/stomach.png'),
      missionInfo: {},
      doctorOrderTab: 0,
      hasPatiantFlag: false,
      patientInfo: {},
      insideDoctorOrderTab: 1,
      tab1Class: 'modal-title-text modal-title-text-menu mr-2 active-tab',
      tab2Class: 'modal-title-text-menu mr-2',
      tab3Class: 'modal-title-text-menu mr-2',
      tab4Class: 'modal-title-text-menu mr-2',
      tab5Class: 'modal-title-text-menu mr-2',
      tab6Class: 'modal-title-text-menu mr-2',
      tab7Class: 'modal-title-text-menu mr-2',
      patientId: null,
      passedTime: 0,
      passedTimeInterval: null,
      showPassedTime: null,
      //note
      noteList: [],
      noteText: '',
      disabelNoteConfirm: false,
      //address
      addressDataTableHeader: [],
      addressDataTableItems: [],
      phoneOnlineLocationInterval: null,
      mapSingleMovingIconInterval: null,
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      //action
      //result
      otherResultItem: [
        { text: 'قطع حین مکالمه', id: 1 },
        { text: 'توصیه به مراجعه', id: 2 },
        { text: 'نامشخص', id: 3 },
      ],
      deliverResultItem: [
        { text: '10-33', id: 1 },
        { text: '10-99', id: 2 },
        { text: '10-96', id: 3 },
      ],
      notDeliverResultItem: [
        { text: '10-35', id: 1 },
        { text: '10-19', id: 2 },
        { text: '10-29', id: 3 },
      ],
      selectedResult: null,
      tempSelectedResult: '',
      selectedChiefComplaint: '',
      patientDoctorOrders: [],
      patientDoctorActions: [],
      doctorNote: '',
      startDate: '',
      endDate: '',
      //drugModal
      drugModal: false,
      selectedDrugGroup: null,
      selectedDrug: null,
      selectedDrugOrderType: null,
      drugCount: null,
      selectedIsStandBy: null,
      allMyDrugOrderType: [],
      drugStandByItems: [
        { title: 'استفاده شود', id: 1 },
        { title: 'آماده استفاده', id: 2 },
      ],
      //generalActionModal
      generalActionModal: false,
      selectedGeneralActions: [],
      serachGeneralAction: '',
      //hospital

      polyline: {
        latlngs: [],
        color: '#49454F',
      },
      doctorOrderTabs: [],
    };
  },
  methods: {
    //

    toggleTimer: function () {
      this.passedTimeInterval = setInterval(this.incrementTime, 1000);
    },
    incrementTime: function () {
      this.passedTime = parseInt(this.passedTime) + 1;
      this.showPassedTime = new Date(this.passedTime * 1000).toISOString().substring(14, 19);
    },
    changeTab: function (type) {
      if (type == 1) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.tab2Class = 'modal-title-text-menu mr-2';
        this.tab3Class = 'modal-title-text-menu mr-2';
        this.tab4Class = 'modal-title-text-menu mr-2';
        this.tab5Class = 'modal-title-text-menu mr-2';
        this.tab6Class = 'modal-title-text-menu mr-2';
        this.tab7Class = 'modal-title-text-menu mr-2';
        this.doctorOrderTab = 1;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (type == 2) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text-menu mr-2';
        this.tab2Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.tab3Class = 'modal-title-text-menu mr-2';
        this.tab4Class = 'modal-title-text-menu mr-2';
        this.tab5Class = 'modal-title-text-menu mr-2';
        this.tab6Class = 'modal-title-text-menu mr-2';
        this.tab7Class = 'modal-title-text-menu mr-2';
        this.doctorOrderTab = 2;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (type == 3) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text-menu mr-2';
        this.tab2Class = 'modal-title-text-menu mr-2';
        this.tab3Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.tab4Class = 'modal-title-text-menu mr-2';
        this.tab5Class = 'modal-title-text-menu mr-2';
        this.tab6Class = 'modal-title-text-menu mr-2';
        this.tab7Class = 'modal-title-text-menu mr-2';
        this.doctorOrderTab = 3;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (type == 4) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text-menu mr-2';
        this.tab2Class = 'modal-title-text-menu mr-2';
        this.tab3Class = 'modal-title-text-menu mr-2';
        this.tab4Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.tab5Class = 'modal-title-text-menu mr-2';
        this.tab6Class = 'modal-title-text-menu mr-2';
        this.tab7Class = 'modal-title-text-menu mr-2';
        this.doctorOrderTab = 4;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (type == 5) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text-menu mr-2';
        this.tab2Class = 'modal-title-text-menu mr-2';
        this.tab3Class = 'modal-title-text-menu mr-2';
        this.tab4Class = 'modal-title-text-menu mr-2';
        this.tab5Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.tab6Class = 'modal-title-text-menu mr-2';
        this.tab7Class = 'modal-title-text-menu mr-2';
        this.doctorOrderTab = 5;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (type == 6) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text-menu mr-2';
        this.tab2Class = 'modal-title-text-menu mr-2';
        this.tab3Class = 'modal-title-text-menu mr-2';
        this.tab4Class = 'modal-title-text-menu mr-2';
        this.tab5Class = 'modal-title-text-menu mr-2';
        this.tab6Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.tab7Class = 'modal-title-text-menu mr-2';
        this.noteText = '';
        this.getAllMissionNoteFunction(this.missionId, this.missionPhoneId);
        this.doctorOrderTab = 6;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      } else if (type == 7) {
        clearInterval(this.mapSingleMovingIconInterval);
        this.tab1Class = 'modal-title-text-menu mr-2';
        this.tab2Class = 'modal-title-text-menu mr-2';
        this.tab3Class = 'modal-title-text-menu mr-2';
        this.tab4Class = 'modal-title-text-menu mr-2';
        this.tab5Class = 'modal-title-text-menu mr-2';
        this.tab6Class = 'modal-title-text-menu mr-2';
        this.tab7Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
        this.getAllMissionAddressLogFunction(this.missionId);

        this.doctorOrderTab = 7;
        this.polyline = {
          latlngs: [],
          color: '#49454F',
        };
      }
    },
    changeInsideTab: function (type) {
      if (type == 1) {
        this.insideDoctorOrderTab = 1;
      } else if (type == 2) {
        this.insideDoctorOrderTab = 2;
      }
    },
    getPatientInformation: function (id) {
      this.patientId = id;
      this.cleanAdamak();
      for (let i = 0; i < this.missionInfo.patients.length; i++) {
        if (id == this.missionInfo.patients[i].id) {
          this.missionInfo.patients[i].class = 'selected-patiant mt-2';
        } else {
          this.missionInfo.patients[i].class = 'not-selected-patiant mt-2';
        }
      }
      // this.getPatientFunction(id);
    },
    //note tab
    readyNoteData: function (data) {
      this.noteList = [];
      for (let i = 0; i < data.length; i++) {
        let user = '';
        let date = '';
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        if (data[i].noteDate) {
          date = Vue.moment(data[i].noteDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        this.noteList.push({
          user: user,
          date: date,
          note: data[i].note ? data[i].note : '-',
          id: data[i].id,
        });
      }
    },
    noteHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.addNote();
      }
    },
    addNote: function () {
      this.disabelNoteConfirm = true;
      if (!this.noteText) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      if (!this.noteText.replace(/\s/g, '').length) {
        this.snackText = 'توضیحات نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelNoteConfirm = false;
        return;
      }
      this.addNoteToMissionFucntion(this.noteText, this.missionId, this.missionPhoneId);
    },
    //address
    readyAddressLogData: function (data) {
      this.addressDataTableHeader = [
        { text: 'آدرس', value: 'address', align: 'center', sortable: false },
        { text: 'تاریخ', value: 'date', align: 'center', sortable: false },
        { text: 'کاربر', value: 'user', align: 'center', sortable: false },
      ];
      this.addressDataTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        let user = '';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss - jYYYY/jM/jD');
        }
        if (data[i].user) {
          let fName = data[i].user.firstName ? data[i].user.firstName : '-';
          let lName = data[i].user.lastName ? data[i].user.lastName : '-';
          user = fName + ' ' + lName;
        }
        this.addressDataTableItems.push({
          date: date,
          address: data[i].address ? data[i].address : '-',
          user: user,
        });
      }
    },
    clearSetIntrvals: function () {
      clearInterval(this.mapSingleMovingIconInterval);
    },
    //result
    selectResult: function (type) {
      if (type == 'other') {
        this.selectedResult = null;
        this.tempSelectedResult = 'other';
      } else if (type == 'deliver') {
        this.selectedResult = null;
        this.tempSelectedResult = 'deliver';
      } else if (type == 'notDeliver') {
        this.selectedResult = null;
        this.tempSelectedResult = 'notDeliver';
      }
    },
    //drug modal
    showDrugModal: function () {
      this.drugModal = true;
    },
    cancelAddDoctorDrug: function () {
      this.selectedDrugGroup = null;
      this.selectedDrug = null;
      this.selectedDrugOrderType = null;
      this.drugCount = null;
      this.selectedIsStandBy = null;
      this.allMyDrugOrderType = [];
      this.drugModal = false;
    },
    drugGroupChange: function () {
      this.selectedDrug = null;
      this.selectedDrugOrderType = null;
      if (this.selectedDrugGroup) {
        if (this.selectedDrugGroup.id) {
          this.getListOfDrugsForOtherWithGroupId(this.selectedDrugGroup.id);
        }
      }
    },
    drugChange: function () {
      this.selectedDrugOrderType = null;
      if (this.selectedDrug) {
        if (this.selectedDrug.id) {
          this.allMyDrugOrderType = [];
          for (let i = 0; i < this.selectedDrug.orderTypes.length; i++) {
            this.allMyDrugOrderType.push({
              title: this.selectedDrug.orderTypes[i].title,
              id: this.selectedDrug.orderTypes[i].id,
            });
          }
        }
      }
    },
    addDoctorDrug: function () {
      if (!this.selectedDrugGroup) {
        this.snackText = 'گروه دارویی نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.selectedDrug) {
        this.snackText = 'دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.selectedDrugOrderType) {
        this.snackText = 'نحوه تجویز نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.drugCount == null || this.drugCount == undefined) {
        this.snackText = 'تعداد دارو نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (!this.selectedIsStandBy) {
        this.snackText = 'دستور استفاده نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      this.patientDoctorOrders.push({
        drugGroupId: this.selectedDrugGroup.id,
        drugGroupTitle: this.selectedDrugGroup.title,
        drugId: this.selectedDrug.id,
        drugtitle: this.selectedDrug.title,
        orderTypeId: this.selectedDrugOrderType.id,
        orderTypeTitle: this.selectedDrugOrderType.title,
        drugCount: this.drugCount,
        standById: this.selectedIsStandBy.id,
        standByTitle: this.selectedIsStandBy.title,
        showDetail: false,
        id: this.patientDoctorOrders.length + 1,
      });
      this.selectedDrugGroup = null;
      this.selectedDrug = null;
      this.selectedDrugOrderType = null;
      this.drugCount = null;
      this.selectedIsStandBy = null;
      this.allMyDrugOrderType = [];
      this.drugModal = false;
    },
    showDrugsDtail: function (id, type) {
      if (type == 'open') {
        let temp = this.patientDoctorOrders;
        for (let i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].showDetail = true;
          }
        }
        this.patientDoctorOrders = [];
        this.patientDoctorOrders = temp;
      } else if (type == 'close') {
        let temp = this.patientDoctorOrders;
        for (let i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].showDetail = false;
          }
        }
        this.patientDoctorOrders = [];
        this.patientDoctorOrders = temp;
      }
    },
    removeItemFromDrugs: function (id) {
      for (var i = 0; i < this.patientDoctorOrders.length; i++) {
        if (this.patientDoctorOrders[i].id == id) {
          this.patientDoctorOrders.splice(i, 1);
        }
      }
    },
    //general action
    showGeneralActionModal: function () {
      this.generalActionModal = true;
    },
    addGeneralAction: function () {
      const selectedTitleActions = [...this.selectedGeneralActions]?.map(({ title }) => title);
      let allItems = [...selectedTitleActions, ...this.patientDoctorActions];
      this.patientDoctorActions = Array.from(new Set(allItems));
      this.cancelAddGeneralAction();
    },
    cancelAddGeneralAction: function () {
      this.serachGeneralAction = '';
      this.generalActionModal = false;
    },
    removeItemFromGeneralAction: function (text) {
      for (var i = 0; i < this.patientDoctorActions.length; i++) {
        if (this.patientDoctorActions[i] === text) {
          this.patientDoctorActions.splice(i, 1);
        }
      }
    },
    //hospital
    showHospitalModal: function () {
      this.changeHospitalModal = true;
      this.getListOfAllActiveHospitalsFunction();
    },
    setChangeHospital: function () {
      if (!this.selectedHospital) {
        this.snackText = 'بیمارستان را انتخاب نمایید';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        return;
      }
      if (this.hasHospital == true) {
        if (!this.changeHospitalNote) {
          this.snackText = 'توضیحات را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          return;
        }
        if (!this.changeHospitalNote.replace(/\s/g, '').length) {
          this.snackText = 'توضیحات را وارد نمایید';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      } else {
        this.changeHospitalNote = '';
      }
      this.sendMissionToHospitalFunction();
    },

    closeModal: function () {
      this.missionInfo = {};
      this.doctorOrderTab = 1;
      this.hasPatiantFlag = false;
      this.patientInfo = {};
      this.insideDoctorOrderTab = 1;
      this.tab1Class = 'modal-title-text modal-title-text-menu mr-2 active-tab';
      this.tab2Class = 'modal-title-text-menu mr-2';
      this.tab3Class = 'modal-title-text-menu mr-2';
      this.tab4Class = 'modal-title-text-menu mr-2';
      this.tab5Class = 'modal-title-text-menu mr-2';
      this.tab6Class = 'modal-title-text-menu mr-2';
      this.tab7Class = 'modal-title-text-menu mr-2';
      this.patientId = null;
      this.noteList = [];
      this.noteText = '';
      this.disabelNoteConfirm = false;
      this.addressDataTableHeader = [];
      this.addressDataTableItems = [];
      clearInterval(this.mapSingleMovingIconInterval);
      this.mapSingleMovingIconInterval = null;
      this.selectedResult = null;
      this.tempSelectedResult = '';
      this.selectedChiefComplaint = '';
      this.patientDoctorOrders = [];
      this.patientDoctorActions = [];
      this.doctorNote = '';
      this.startDate = '';
      this.endDate = '';
      this.drugModal = false;
      this.selectedDrugGroup = null;
      this.selectedDrug = null;
      this.selectedDrugOrderType = null;
      this.drugCount = null;
      this.selectedIsStandBy = null;
      this.allMyDrugOrderType = [];
      this.generalActionModal = false;
      this.selectedGeneralActions = [];
      this.serachGeneralAction = '';
      clearInterval(this.passedTimeInterval);
      this.passedTimeInterval = null;
      this.showPassedTime = null;
      this.polyline = {
        latlngs: [],
        color: '#49454F',
      };
      this.$root.$refs.DoctorMissions.orderModal = false;
    },
    cleanAdamak: function () {
      this.$refs.humanFront.fill1 = 'none';
      this.$refs.humanFront.fill2 = 'none';
      this.$refs.humanFront.fill3 = 'none';
      this.$refs.humanFront.fill4 = 'none';
      this.$refs.humanFront.fill5 = 'none';
      this.$refs.humanFront.fill6 = 'none';
      this.$refs.humanFront.fill7 = 'none';
      this.$refs.humanFront.fill8 = 'none';
      this.$refs.humanFront.fill9 = 'none';
      this.$refs.humanFront.fill10 = 'none';
      this.$refs.humanFront.fill11 = 'none';
      this.$refs.humanFront.fill12 = 'none';
      this.$refs.humanFront.fill13 = 'none';
      this.$refs.humanFront.fill14 = 'none';
      this.$refs.humanFront.fill15 = 'none';
      this.$refs.humanFront.fill16 = 'none';
      this.$refs.humanFront.fill17 = 'none';
      this.$refs.humanFront.fill18 = 'none';
      this.$refs.humanFront.fill19 = 'none';
      this.$refs.humanFront.fill20 = 'none';
      this.$refs.humanFront.fill21 = 'none';
      this.$refs.humanFront.fill22 = 'none';
      this.$refs.humanFront.fill23 = 'none';
      this.$refs.humanFront.fill24 = 'none';
      this.$refs.humanFront.fill25 = 'none';
      this.$refs.humanFront.fill26 = 'none';
      this.$refs.humanFront.fill27 = 'none';
      this.$refs.humanFront.fill28 = 'none';
      this.$refs.humanFront.fill29 = 'none';
      this.$refs.humanFront.fill30 = 'none';
      this.$refs.humanFront.fill31 = 'none';
      this.$refs.humanFront.fill32 = 'none';
      this.$refs.humanFront.fill33 = 'none';
      this.$refs.humanFront.fill34 = 'none';
      this.$refs.humanFront.fill35 = 'none';
      this.$refs.humanFront.fill36 = 'none';
      this.$refs.humanFront.fill37 = 'none';
      this.$refs.humanFront.fill38 = 'none';
      this.$refs.humanFront.fill39 = 'none';
      this.$refs.humanFront.fill40 = 'none';
      this.$refs.humanFront.fill41 = 'none';
      this.$refs.humanFront.fill42 = 'none';
      this.$refs.humanFront.fill43 = 'none';
      this.$refs.humanFront.fill44 = 'none';
      this.$refs.humanBack.backFill1 = 'none';
      this.$refs.humanBack.backFill2 = 'none';
      this.$refs.humanBack.backFill3 = 'none';
      this.$refs.humanBack.backFill4 = 'none';
      this.$refs.humanBack.backFill5 = 'rectangle-7037';
      this.$refs.humanBack.backFill6 = 'rectangle-7039';
      this.$refs.humanBack.backFill7 = 'rectangle-7038';
      this.$refs.humanBack.backFill8 = 'none';
      this.$refs.humanBack.backFill9 = 'none';
      this.$refs.humanBack.backFill10 = 'none';
      this.$refs.humanBack.backFill11 = 'none';
      this.$refs.humanBack.backFill12 = 'none';
      this.$refs.humanBack.backFill13 = 'none';
      this.$refs.humanBack.backFill14 = 'none';
      this.$refs.humanBack.backFill15 = 'none';
      this.$refs.humanBack.backFill16 = 'none';
      this.$refs.humanBack.backFill17 = 'none';
      this.$refs.humanBack.backFill18 = 'none';
      this.$refs.humanBack.backFill19 = 'none';
      this.$refs.humanBack.backFill20 = 'none';
      this.$refs.humanBack.backFill21 = 'none';
      this.$refs.humanBack.backFill22 = 'none';
      this.$refs.humanBack.backFill23 = 'none';
      this.$refs.humanBack.backFill24 = 'rectangle-7040';
      this.$refs.humanBack.backFill25 = 'none';
      this.$refs.humanBack.backFill26 = 'none';
      this.$refs.humanBack.backFill27 = 'none';
      this.$refs.humanBack.backFill28 = 'none';
      this.$refs.humanBack.backFill29 = 'none';
      this.$refs.humanBack.backFill30 = 'none';
      this.$refs.humanBack.backFill31 = 'none';
      this.$refs.humanBack.backFill32 = 'none';
      this.$refs.humanBack.backFill33 = 'none';
      this.$refs.humanBack.backFill34 = 'none';
      this.$refs.humanBack.backFill35 = 'none';
      this.$refs.humanBack.backFill36 = 'none';
      this.$refs.humanBack.backFill37 = 'none';
      this.$refs.humanBack.backFill38 = 'none';
      this.$refs.humanBack.backFill39 = 'none';
      this.$refs.humanBack.backFill40 = 'none';
      this.$refs.humanBack.backFill41 = 'none';
      this.$refs.humanBack.backFill42 = 'none';
      this.$refs.humanBack.backFill43 = 'none';
      this.$refs.humanBack.backFill44 = 'none';
    },
    setAdamakColor: function (data) {
      if (data.isFront == true) {
        switch (data.bodyPartId) {
          case 1:
            this.$refs.humanFront.fill1 = data.color;
            break;
          case 2:
            this.$refs.humanFront.fill2 = data.color;
            break;
          case 3:
            this.$refs.humanFront.fill3 = data.color;
            break;
          case 4:
            this.$refs.humanFront.fill4 = data.color;
            break;
          case 5:
            this.$refs.humanFront.fill5 = data.color;
            break;
          case 6:
            this.$refs.humanFront.fill6 = data.color;
            break;
          case 7:
            this.$refs.humanFront.fill7 = data.color;
            break;
          case 8:
            this.$refs.humanFront.fill8 = data.color;
            break;
          case 9:
            this.$refs.humanFront.fill9 = data.color;
            break;
          case 10:
            this.$refs.humanFront.fill10 = data.color;
            break;
          case 11:
            this.$refs.humanFront.fill11 = data.color;
            break;
          case 12:
            this.$refs.humanFront.fill12 = data.color;
            break;
          case 13:
            this.$refs.humanFront.fill13 = data.color;
            break;
          case 14:
            this.$refs.humanFront.fill14 = data.color;
            break;
          case 15:
            this.$refs.humanFront.fill15 = data.color;
            break;
          case 16:
            this.$refs.humanFront.fill16 = data.color;
            break;
          case 17:
            this.$refs.humanFront.fill17 = data.color;
            break;
          case 18:
            this.$refs.humanFront.fill18 = data.color;
            break;
          case 19:
            this.$refs.humanFront.fill19 = data.color;
            break;
          case 20:
            this.$refs.humanFront.fill20 = data.color;
            break;
          case 21:
            this.$refs.humanFront.fill21 = data.color;
            break;
          case 22:
            this.$refs.humanFront.fill22 = data.color;
            break;
          case 23:
            this.$refs.humanFront.fill23 = data.color;
            break;
          case 24:
            this.$refs.humanFront.fill24 = data?.color;
            break;
          case 25:
            this.$refs.humanFront.fill25 = data.color;
            break;
          case 26:
            this.$refs.humanFront.fill26 = data.color;
            break;
          case 27:
            this.$refs.humanFront.fill27 = data.color;
            break;
          case 28:
            this.$refs.humanFront.fill28 = data.color;
            break;
          case 29:
            this.$refs.humanFront.fill29 = data.color;
            break;
          case 30:
            this.$refs.humanFront.fill30 = data.color;
            break;
          case 31:
            this.$refs.humanFront.fill31 = data.color;
            break;
          case 32:
            this.$refs.humanFront.fill32 = data.color;
            break;
          case 33:
            this.$refs.humanFront.fill33 = data.color;
            break;
          case 34:
            this.$refs.humanFront.fill34 = data.color;
            break;
          case 35:
            this.$refs.humanFront.fill35 = data.color;
            break;
          case 36:
            this.$refs.humanFront.fill36 = data.color;
            break;
          case 37:
            this.$refs.humanFront.fill37 = data.color;
            break;
          case 38:
            this.$refs.humanFront.fill38 = data.color;
            break;
          case 39:
            this.$refs.humanFront.fill39 = data.color;
            break;
          case 40:
            this.$refs.humanFront.fill40 = data.color;
            break;
          case 41:
            this.$refs.humanFront.fill41 = data.color;
            break;
          case 42:
            this.$refs.humanFront.fill42 = data.color;
            break;
          case 43:
            this.$refs.humanFront.fill43 = data.color;
            break;
          case 44:
            this.$refs.humanFront.fill44 = data.color;
            break;
        }
      } else if (data.isFront == false) {
        switch (data.bodyPartId) {
          case 1:
            this.$refs.humanBack.backFill1 = data.color;
            break;
          case 2:
            this.$refs.humanBack.backFill2 = data.color;
            break;
          case 3:
            this.$refs.humanBack.backFill3 = data.color;
            break;
          case 4:
            this.$refs.humanBack.backFill4 = data.color;
            break;
          case 5:
            this.$refs.humanBack.backFill5 = 'rectangle-7037-fill';
            break;
          case 6:
            this.$refs.humanBack.backFill6 = 'rectangle-7039-fill';
            break;
          case 7:
            this.$refs.humanBack.backFill7 = 'rectangle-7038-fill';
            break;
          case 8:
            this.$refs.humanBack.backFill8 = data.color;
            break;
          case 9:
            this.$refs.humanBack.backFill9 = data.color;
            break;
          case 10:
            this.$refs.humanBack.backFill10 = data.color;
            break;
          case 11:
            this.$refs.humanBack.backFill11 = data.color;
            break;
          case 12:
            this.$refs.humanBack.backFill12 = data.color;
            break;
          case 13:
            this.$refs.humanBack.backFill13 = data.color;
            break;
          case 14:
            this.$refs.humanBack.backFill14 = data.color;
            break;
          case 15:
            this.$refs.humanBack.backFill15 = data.color;
            break;
          case 16:
            this.$refs.humanBack.backFill16 = data.color;
            break;
          case 17:
            this.$refs.humanBack.backFill17 = data.color;
            break;
          case 18:
            this.$refs.humanBack.backFill18 = data.color;
            break;
          case 19:
            this.$refs.humanBack.backFill19 = data.color;
            break;
          case 20:
            this.$refs.humanBack.backFill20 = data.color;
            break;
          case 21:
            this.$refs.humanBack.backFill21 = data.color;
            break;
          case 22:
            this.$refs.humanBack.backFill22 = data.color;
            break;
          case 23:
            this.$refs.humanBack.backFill23 = data.color;
            break;
          case 24:
            this.$refs.humanBack.backFill24 = 'rectangle-7040-fill';
            break;
          case 25:
            this.$refs.humanBack.backFill25 = data.color;
            break;
          case 26:
            this.$refs.humanBack.backFill26 = data.color;
            break;
          case 27:
            this.$refs.humanBack.backFill27 = data.color;
            break;
          case 28:
            this.$refs.humanBack.backFill28 = data.color;
            this.$refs.humanBack.toolTip28 = data.typeOfInjury;
            break;
          case 29:
            this.$refs.humanBack.backFill29 = data.color;
            break;
          case 30:
            this.$refs.humanBack.backFill30 = data.color;
            break;
          case 31:
            this.$refs.humanBack.backFill31 = data.color;
            break;
          case 32:
            this.$refs.humanBack.backFill32 = data.color;
            break;
          case 33:
            this.$refs.humanBack.backFill33 = data.color;
            break;
          case 34:
            this.$refs.humanBack.backFill34 = data.color;
            break;
          case 35:
            this.$refs.humanBack.backFill35 = data.color;
            break;
          case 36:
            this.$refs.humanBack.backFill36 = data.color;
            break;
          case 37:
            this.$refs.humanBack.backFill37 = data.color;
            break;
          case 38:
            this.$refs.humanBack.backFill38 = data.color;
            break;
          case 39:
            this.$refs.humanBack.backFill39 = data.color;
            break;
          case 40:
            this.$refs.humanBack.backFill40 = data.color;
            break;
          case 41:
            this.$refs.humanBack.backFill41 = data.color;
            break;
          case 42:
            this.$refs.humanBack.backFill42 = data.color;
            break;
          case 43:
            this.$refs.humanBack.backFill43 = data.color;
            break;
          case 44:
            this.$refs.humanBack.backFill44 = data.color;
            break;
        }
      }
    },
    showPatientAccompanyingSymptomsDetail: function (id, type) {
      let temp = [];
      for (let i = 0; i < this.patientInfo.patientAccompanyingSymptoms.length; i++) {
        temp.push(this.patientInfo.patientAccompanyingSymptoms[i]);
      }
      this.patientInfo.patientAccompanyingSymptoms = [];
      if (type == 'open') {
        for (let i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].showDetail = true;
          }
        }
      } else if (type == 'close') {
        for (let i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].showDetail = false;
          }
        }
      }
      this.patientInfo.patientAccompanyingSymptoms = temp;
    },
    showLine: function () {
      if (this.missionPhoneId) {
        this.getMissionPhoneLocationsFunction(this.missionPhoneId);
      }
    },
    loadPath: function (data) {
      this.polyline.latlngs = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          let temp = [];
          temp.push(data[i].latitude);
          temp.push(data[i].longitude);
          this.polyline.latlngs.push(temp);
        }
      }
    },
    // action-sidebar
    updateChiefComplaint: function (chiefComplaintText) {
      this.selectedChiefComplaint = chiefComplaintText;
    },
    updateNoteText: function (text) {
      this.noteText = text;
    },
    updateSelectedResult: function (result) {
      this.selectedResult = result;
    },
  },
  watch: {
    hasPatiantFlag: {
      handler: function (currentVal) {
        let doctorOrderTabs = [];
        if (currentVal) {
          doctorOrderTabs = [
            'اطلاعات ماموریت',
            'شرح حال',
            'سوابق دارویی و پزشکی',
            'معاینات',
            'معاینات سر تا پا',
            'علائم و اقدامات',
            'تریاژ تلفنی',
            'موقعیت آمبولانس',
            'توضیحات',
          ];
        } else {
          doctorOrderTabs = ['اطلاعات ماموریت', 'تریاژ تلفنی', 'موقعیت آمبولانس', 'توضیحات'];
        }
        this.doctorOrderTabs = doctorOrderTabs;
      },
      immediate: true,
    },
  },
};
